/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const FETCH_COLLECTION_NOTES_SUCCESS = 'FETCH_COLLECTION_NOTES_SUCCESS';

export function fetchCollectionNotes(payload){
    return {type : FETCH_COLLECTION_NOTES_SUCCESS, payload: payload };
}

export const SAVE_COLLECTION_NOTES_SUCCESS = 'SAVE_COLLECTION_NOTES_SUCCESS';

export function saveCollectionNotes(payload){
    return {type : SAVE_COLLECTION_NOTES_SUCCESS, payload: payload };
}


// WEBPACK FOOTER //
// ./src/_actions/collection.notes.action.js